var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconViews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-views",
    transform: "translate(-29 -358)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-transp",
    width: 20,
    height: 20,
    transform: "translate(29 358)",
    fill: "#96969f",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-views-2",
    "data-name": "icon-views",
    d: "M9-5a2,2,0,0,0,2-2A2,2,0,0,0,9-9c-.031,0-.059.008-.089.009A1.775,1.775,0,0,1,9-8.484,1.485,1.485,0,0,1,7.516-7a1.775,1.775,0,0,1-.507-.089C7.009-7.058,7-7.03,7-7A2,2,0,0,0,9-5Zm8.891-1.456A10.023,10.023,0,0,0,9-12,10.025,10.025,0,0,0,.109-6.456,1.2,1.2,0,0,0,0-6a1.2,1.2,0,0,0,.109.456A10.023,10.023,0,0,0,9,0a10.025,10.025,0,0,0,8.891-5.544A1.2,1.2,0,0,0,18-6,1.2,1.2,0,0,0,17.891-6.456ZM9-11a4,4,0,0,1,4,4A4,4,0,0,1,9-3,4,4,0,0,1,5-7,4.008,4.008,0,0,1,9-11ZM9-1A9.008,9.008,0,0,1,1-6a10.768,10.768,0,0,1,4.056-4.042A4.954,4.954,0,0,0,4-7,5,5,0,0,0,9-2a5,5,0,0,0,5-5,4.954,4.954,0,0,0-1.056-3.042A10.768,10.768,0,0,1,17-6,9.008,9.008,0,0,1,9-1Z",
    transform: "translate(30 374)",
    fill: "#96969f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViews);
export default __webpack_public_path__ + "static/media/icon-views.0bc4818c5fdb06d9213bc6861418e175.svg";
export { ForwardRef as ReactComponent };